import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-g01-item-list-header" }
const _hoisted_2 = { class: "p-g01-item-list-header__info" }
const _hoisted_3 = { class: "p-g01-item-list-header__info__label" }
const _hoisted_4 = { class: "p-g01-item-list-header__info__label p-g01-item-list-header__info__label--point" }
const _hoisted_5 = {
  key: 0,
  class: "p-g01-item-list-header__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconItemCategory = _resolveComponent("IconItemCategory")!
  const _component_IconPoint = _resolveComponent("IconPoint")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isCategory)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_IconItemCategory, {
              id: _ctx.id,
              class: "p-g01-item-list-header__info__icon"
            }, null, 8, ["id"]),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.label), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_IconPoint, {
              "icon-size": 24,
              class: "p-g01-item-list-header__info__icon"
            }),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.label), 1)
          ], 64))
    ]),
    (_ctx.isCategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ButtonMain, {
            tag: 'button',
            onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToProductList())),
            kind: "secondary"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("このカテゴリーの商品をもっと見る", -1)
            ])),
            _: 1,
            __: [1]
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}